import {
  DOCTOR_WITH_CUSTOMER_SUCCESS,
  DOCTOR_WITH_CUSTOMER_FAIL,
  SET_MESSAGE,
  DOCTOR_WITH_CUSTOMER_PENDING,
} from "../types";
import UserService from "../../services/user.service";
import { toast } from "react-toastify";

export const getDoctorsWithCustomerRank = (body) => (dispatch) => {
  dispatch({
    type: DOCTOR_WITH_CUSTOMER_PENDING,
    payload: { doctors: "isLoading" },
  });
  
  const requestBody = typeof body === 'object' ? body : {
    rankId: body,
    pageNumber: 1,
    pageSize: 10,
    textSearch: "",
    cityId: 0,
    practiceLocationId: 0
  };
  
  return UserService.getDoctorsWithCustomer(requestBody)
    .then(response => {
      if (response.data.status) {
        dispatch({
          type: DOCTOR_WITH_CUSTOMER_SUCCESS,
          payload: { 
            doctors: response.data.result,
            totalCount: response.data.totalCount,
            totalPages: response.data.totalPages
          },
        });
        return Promise.resolve();
      } else {
        dispatch({ type: DOCTOR_WITH_CUSTOMER_FAIL });
        toast.error(response.data.message );
        return Promise.reject();
      }
    })
    .catch(error => {
      const message = 
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message 
      dispatch({ type: DOCTOR_WITH_CUSTOMER_FAIL });
      dispatch({ type: SET_MESSAGE, payload: message });
      
      toast.error(message);
      
      return Promise.reject(error);
    });
};